import React, { useState, useMemo } from 'react';
import moment from 'moment';
import MUIDataTable from 'mui-datatables';

import CustomToolbar from 'components/CustomToolbar/CustomToolbar';
import EmployeeInfoModal from 'components/Employees/EmployeeInfoModal';
import ExpectedSalaryModal from 'components/Employees/ExpectedSalaryModal';

const EmployeesTable = (props) => {

  const [rowsSelected, setRowsSelected] = useState([]);
  const [openExpectedModal, setOpenExpectedModal] = useState(false);

  const [openInfoModal, setOpenInfoModal] = useState(false);
  const [employeeInfo, setEmployeeInfo] = useState({});

  const tableData = useMemo(() => {
    const initialTableData = [];

    for ( let i = 0; i < props.employees.length; i++ ) {
      const employee = props.employees[i];
      initialTableData.push({
        id: employee.id,
        displayId: employee.displayId,
        name: employee.name,
        phone: employee.phone,
        department: employee.department,
        date: moment(employee.joiningDate).format('DD/MM/YYYY')
      });
    }

    return initialTableData;
    
  }, [props.employees]);

  const columns = [
    { label: "ID", name: "displayId" },
    { label: "Employee Name", name: "name"},
    { label: "Phone", name: "phone" },
    { label: "Department", name: "department" },
    { label: "Joining Date", name: "date" }
  ];

  const closeInfoModal = () => {
    setOpenInfoModal(false);
    setEmployeeInfo({});
  };

  const updateExpectedSalary = () => {
    setOpenExpectedModal(true);
  };

  const closeExpectedSalaryModal = () => {
    setOpenExpectedModal(false);
    setRowsSelected([]);
  };

  const onRowSelectionChange = (curr, all, rowsSelected) => {
    setRowsSelected(rowsSelected);
    if(rowsSelected.length === 1) {
      const employeeInfo = props.employees[rowsSelected[0]];
      props.setUpdateInfo({
        id: employeeInfo.id,
        name: employeeInfo.name,
        phone: employeeInfo.phone,
        department: employeeInfo.department,
        joiningDate: moment(employeeInfo.joiningDate).format('YYYY-MM-DD')
      });
    }
  };

  const customToolbarSelect = (selectedRows) => {
    return(
      <CustomToolbar
        switchy={5}
        setUpdate={props.updateEmployee}
        updateExpectedSalary={updateExpectedSalary}
      />
    )
  };
  
  const options = {
    filterType: 'dropdown',
    onRowSelectionChange,
    selectableRowsOnClick: false,
    selectableRows: "single",
    customToolbarSelect,
    rowsSelected,
    setRowProps: (row, dataIndex, rowIndex) => ({
      onDoubleClick: () => {
        if(!rowsSelected[0]) {
          setEmployeeInfo(props.employees[dataIndex]);
          setOpenInfoModal(true);
        }
      }
    })
  };

  return(
    <React.Fragment>
    <MUIDataTable
      title={"Employee List"}
      data={tableData}
      columns={columns}
      options={options}
    />
    { openInfoModal ?
    <EmployeeInfoModal
      open={openInfoModal}
      employeeInfo={employeeInfo}
      expenses={props.expenses}
      closeModal={closeInfoModal}
    />
    : null }
    { openExpectedModal ?
    <ExpectedSalaryModal
      open={openExpectedModal}
      employeeId={tableData[rowsSelected[0]].id}
      closeModal={closeExpectedSalaryModal}
    />
    : null }
    </React.Fragment>
  )
};

export default EmployeesTable;